import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
import { CompanyNotificationsState } from '../_reducers/company-notification.reducers';
import { CompanyNotificationModel } from '../../../notification/models/company-notification.model';

export const selectCompanyNotificationsState =
  createFeatureSelector<CompanyNotificationsState>('companyNotifications');

export const selectCompanyNotificationById = (companyNotificationId: number) =>
  createSelector(
    selectCompanyNotificationsState,
    (companyNotificationsState) => companyNotificationsState.entities[companyNotificationId],
  );

export const selectCompanyNotificationsPageLoading = createSelector(
  selectCompanyNotificationsState,
  (companyNotificationsState) => companyNotificationsState.listLoading,
);

export const selectCompanyNotificationsActionLoading = createSelector(
  selectCompanyNotificationsState,
  (companyNotificationsState) => companyNotificationsState.actionsloading,
);

export const selectLastCreatedCompanyNotificationId = createSelector(
  selectCompanyNotificationsState,
  (companyNotificationsState) => companyNotificationsState.lastCreatedCompanyNotificationId,
);

export const selectCompanyNotificationError = createSelector(
  selectCompanyNotificationsState,
  (companyNotificationsState) => companyNotificationsState.error,
);

export const selectCompanyNotificationLatestSuccessfullAction = createSelector(
  selectCompanyNotificationsState,
  (companyNotificationsState) => companyNotificationsState.latestSuccessfullAction,
);

export const selectCompanyNotificationsShowInitWaitingMessage = createSelector(
  selectCompanyNotificationsState,
  (companyNotificationsState) => companyNotificationsState.showInitWaitingMessage,
);

export const selectCompanyNotificationsInStore = createSelector(
  selectCompanyNotificationsState,
  (companyNotificationsState) => {
    const items: CompanyNotificationModel[] = [];
    each(companyNotificationsState.entities, (element) => {
      items.push(element);
    });
    const httpExtension = new HttpExtenstionsModel();
    const result: CompanyNotificationModel[] = httpExtension.sortArray(
      items,
      companyNotificationsState.lastQuery.sortField,
      companyNotificationsState.lastQuery.sortOrder,
    );
    return new QueryResultsModel(result, companyNotificationsState.totalCount);
  },
);
